import {createAction, createReducer} from '@reduxjs/toolkit';

import {CardType, CreditCardType} from 'desktop/types/creditCardType';

import {
    completeOrderReview,
    completeOrderReviewPaypal,
} from '../../../actions/completeOrder/completeOrder';
import {resetCheckoutSteps} from '../../status/status';
import {setLoadingSavePayment} from '../savePaymentData/savePaymentData';

export const initialState: CreditCardType = {
    cards: [],
    error: '',
    isLoading: false,
    showSavedCards: false,
};

export const setLoading = createAction<boolean>('CHECKOUT@CREDIT_CARD_PAYMENT@SET_LOADING');

export const setCards = createAction<CardType[]>('CHECKOUT@CREDIT_CARD_PAYMENT@SET_CARDS');

export const save = createAction<{
    token: string;
    shouldSave: boolean;
    cvv?: string;
}>('CHECKOUT@CREDIT_CARD_PAYMENT@SAVE');

export const setShowSavedCards = createAction<boolean>(
    'CHECKOUT@CREDIT_CARD_PAYMENT@SET_SHOW_SAVED_CARDS',
);

export const setError = createAction<string>('CHECKOUT@CREDIT_CARD_PAYMENT@SET_ERROR');

/**
 * CreditCard reducer
 *
 * @return {CreditCardType} - credit Card state
 */
export const creditCard = createReducer(initialState, builder =>
    builder
        .addCase(completeOrderReview.rejected, state => ({...state, isLoading: false}))
        .addCase(completeOrderReviewPaypal.rejected, state => ({...state, isLoading: false}))
        .addCase(resetCheckoutSteps, () => initialState)
        .addCase(save, state => ({...state, error: '', isLoading: true}))
        .addCase(setCards, (state, action) => ({
            ...state,
            cards: action.payload,
            showSavedCards: Boolean(action.payload.length),
        }))
        .addCase(setError, (state, action) => ({...state, error: action.payload}))
        .addCase(setLoading, (state, action) => ({...state, isLoading: action.payload}))
        .addCase(setLoadingSavePayment, (state, action) => ({...state, isLoading: action.payload}))
        .addCase(setShowSavedCards, (state, action) => ({
            ...state,
            showSavedCards: action.payload,
        })),
);
